import { calculateCameraECEFTransform } from '@skand/data-3d-loader';
import { Matrix4, Quaternion, Vector2, Vector3 } from 'three';
import { computePick } from '../../Utils';
import { Service } from '../Service';
/**
 * API for deprojecting 2D points onto the scene.
 */
export class DeprojectService extends Service {
    constructor(modules, navigationService) {
        super(modules);
        Object.defineProperty(this, "navigationService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.navigationService = navigationService;
    }
    /**
     * Deproject a list of points on the photo to the 3D scene.
     *
     * @param points
     * @param photo
     * @param cameraModel
     * @param loadDelay
     * @returns
     */
    async points(points, photo, cameraModel, loadDelay = 500) {
        const camera = this.renderer.getWorld().getCamera();
        const currentProjectionMode = this.navigationService.getProjectionMode();
        this.navigationService.setProjectionMode('perspective');
        this.navigationService.disable();
        // Final positions of each vertex on the defect
        const positions = [];
        // Compute the original transform of the camera
        const center = cameraModel.imageSize.clone().divideScalar(2);
        const initial = calculateCameraECEFTransform(center, photo.extrinsicPosition, photo.extrinsicRotation, photo.extrinsicScale, cameraModel);
        const initialTransform = new Matrix4().compose(initial.position, initial.rotation, new Vector3(1, 1, 1));
        const currentTransform = new Matrix4().compose(photo.position, photo.rotation, new Vector3(1, 1, 1));
        const relativeTransform = initialTransform.invert().premultiply(currentTransform);
        // Cast a ray from each vertex of the defect
        for (const coordinate of points) {
            // Center camera so the image coordinate aligns with the renderer's center
            const initial = calculateCameraECEFTransform(coordinate, photo.extrinsicPosition, photo.extrinsicRotation, photo.extrinsicScale, cameraModel);
            const transform = new Matrix4().compose(initial.position, initial.rotation, new Vector3(1, 1, 1));
            transform.premultiply(relativeTransform);
            const cameraPosition = new Vector3();
            const cameraRotation = new Quaternion();
            transform.decompose(cameraPosition, cameraRotation, new Vector3());
            camera.setPositionECEF(cameraPosition);
            camera.setRotation(cameraRotation);
            // Delay to allow the tileset to load
            await new Promise(resolve => setTimeout(resolve, loadDelay));
            // Calculate the projection point
            const { x, y } = this.renderer.getSize();
            const rendererCenter = new Vector2(x / 2, y / 2);
            const pick = computePick(this.renderer, rendererCenter);
            positions.push(pick);
        }
        this.navigationService.enable();
        this.navigationService.setProjectionMode(currentProjectionMode);
        return positions;
    }
    updateFrame(deltaTime) { }
}
